import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from "@angular/common";

@Pipe({name: 'timecardTime'})
export class TimecardTimePipe implements PipeTransform {

  constructor(private DatePipe: DatePipe) {
  }

  transform(time: string | Date): string {
    if (!time) {
      return null;
    }
    let date: Date;
    if (typeof time === 'string') {
      const parts = time.split(':');
      date = new Date(0, 0, 0, +parts[0], +parts[1], +parts[2]);
    } else {
      date = time;
    }
    return this.DatePipe.transform(date, 'shortTime');
  }
}
